// Helpers puros sobre capas del visor de parque solar.

// Filtra las capas cuyo nombre contiene el prefijo del tipo a visualizar.
// Si ninguna coincide, cae a las que NO contienen 'EPC' en el nombre.
export function filterLayersByType(layers, type) {
  const filterType = (type || '').toUpperCase()
  const byType = layers.filter((l) => l.name.indexOf(filterType) !== -1)
  if (byType.length > 0) return byType
  return layers.filter((l) => l.name.indexOf('EPC') === -1)
}
